var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product-carousel product-carousel_type_catalog",
      staticStyle: { "max-width": "1150px" },
      attrs: { id: "product-element-carousel" },
    },
    [
      _c(
        "div",
        { staticClass: "product-carousel__title title title_size_md" },
        [_vm._v("\n        Аналоги\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-carousel__list" }, [
        _c(
          "div",
          {
            staticClass:
              "product-carousel__list-container js-product-detail-carousel",
            class: "s-" + _vm.itemId,
          },
          [
            _c(
              "div",
              { staticClass: "product-carousel__list-wrapper swiper-wrapper" },
              _vm._l(_vm.items, function (item) {
                return _c(
                  "div",
                  { staticClass: "swiper-slide product-carousel__list-item" },
                  [
                    _c("div", { staticClass: "product product_view_box" }, [
                      _c("div", { staticClass: "product__content-inner" }, [
                        _c("div", { staticClass: "product__picture" }, [
                          _c(
                            "a",
                            {
                              staticClass: "product__picture-preview",
                              attrs: { href: item.url },
                            },
                            [
                              item.images.length > 0
                                ? _c("img", {
                                    attrs: { src: item.images[0], alt: "" },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: "/upload/empty/300.png",
                                      alt: "",
                                    },
                                  }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "product__main-info" }, [
                          _c(
                            "a",
                            {
                              staticClass: "product__name",
                              attrs: { href: item.url },
                            },
                            [
                              _vm._v(
                                "\n                                   " +
                                  _vm._s(item.name) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.user.isAuthorized
                          ? _c("div", { staticClass: "product__actions" }, [
                              _c("div", { staticClass: "product__prices" }, [
                                item.price.price != item.price.stock
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product__price product__price_type_old",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              Math.round(
                                                item.price.stock *
                                                  item.step *
                                                  100
                                              ) / 100
                                            ) +
                                            " Р.\n                                        "
                                        ),
                                        item.price.type == "MANUAL"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "percent-badge__value",
                                                  },
                                                  [
                                                    _c(
                                                      "vue-popper",
                                                      {
                                                        attrs: {
                                                          id:
                                                            item.id +
                                                            "-el-percent",
                                                          hint: "Ваша перональная скидка на данную категорию товаров",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.price.percent
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "percent-badge percent-badge_theme_red percent-badge_size_xs product__price-percent",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "percent-badge__value",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.price.percent)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "product__price" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        Math.round(
                                          item.price.price * item.step * 100
                                        ) / 100
                                      ) +
                                      " Р.\n                                    "
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-pagination product-carousel__pagination",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "swiper-arrow-next product-carousel__arrow product-carousel__arrow_next icon icon-arrow-long-left",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "swiper-arrow-prev product-carousel__arrow product-carousel__arrow_prev icon icon-arrow-long-left",
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }